module.exports = __webpack_public_path__ + "img/invoice.79529b39.svg";